import {unwrap} from '@pocketbuy/outdoor-api-client';
import {client} from '../../api';

export type LeaderCandidate = {userId:number;name:string;phone:string|null};
export type ClusterLeadership = {
  id:number;countryCode:string;clusterName:string;status:string;version:number;
  leader:(LeaderCandidate & {accountStatus:string;appointedAt:string})|null;
};
export const clusterLeadershipApi = {
  get:(id:number)=>unwrap<ClusterLeadership>(client.get(`/v1/sales-clusters/${id}/leader`)),
  candidates:(id:number)=>unwrap<LeaderCandidate[]>(client.get(`/v1/sales-clusters/${id}/leader/candidates`)),
  save:(id:number,agentUserId:number|null,expectedVersion:number)=>unwrap<ClusterLeadership>(client.put(`/v1/sales-clusters/${id}/leader`,{agentUserId,expectedVersion})),
};
